/* FWT tyre size reader, shared by header search, predictive search, the finder, size pages and the product page.
   window.FWTSize.read('2754020')        -> { kind:'metric', label:'275/40R20', handle:'275-40r20', ... }
   window.FWTSize.canon('285/30ZR21 100W') -> same object for a variant title (null if it is not a tyre size)
   Shorthand rules: metric widths 125-355 (steps of 5), profiles 25-95 (steps of 5), rims 10-24. 4x4 inch sizes
   without an 'x' only count when the size is in the size list. Anything else is left to normal search. */
(function () {
  'use strict';
  if (window.FWTSize) return;
  var TYRES = '/collections/all-tyres';
  /* 4x4 inch sizes we know even when no product carries the tag yet */
  var KNOWN_INCH = '27x8.50R14 30x9.50R15 31x10.50R15 31x10.50R16 32x11.50R15 33x9.50R15 33x10.50R15 33x10.50R16 33x10.50R17 33x10.50R18 33x11.50R20 33x12.50R15 33x12.50R16 33x12.50R17 33x12.50R18 33x12.50R20 33x12.50R22 33x12.50R24 34x10.50R17 35x10.50R17 35x11.50R17 35x11.50R20 35x12.50R15 35x12.50R17 35x12.50R18 35x12.50R20 35x12.50R22 35x12.50R24 35x13.50R17 35x13.50R20 37x11.50R17 37x12.50R17 37x12.50R18 37x12.50R20 37x12.50R22 37x13.50R17 37x13.50R20 37x13.50R22 37x13.50R24 38x13.50R20 38x15.50R20 40x13.50R17 40x13.50R20 40x15.50R20';
  /* make | model list of the car finder (assets/fwt-vehicles.json) */
  var CARS = 'BMW|3 Series;BMW|X5;BYD|Atto 3;BYD|Seal;BYD|Shark 6;Ford|Everest;Ford|Falcon;Ford|Mustang;Ford|Ranger;Ford|Ranger Raptor;Ford|Territory;GWM|Ute / Cannon;Haval|H6;Haval|Jolion;Holden|Colorado;Holden|Commodore;Honda|CR-V;Honda|Civic;Hyundai|Kona;Hyundai|Santa Fe;Hyundai|Tucson;Hyundai|i30;Isuzu|D-Max;Isuzu|MU-X;Jeep|Grand Cherokee;Jeep|Wrangler;Kia|Cerato;Kia|Sorento;Kia|Sportage;MG|HS;MG|MG3;MG|ZS;Mazda|BT-50;Mazda|CX-3;Mazda|CX-30;Mazda|CX-5;Mazda|Mazda3;Mercedes-Benz|C-Class;Mercedes-Benz|GLC;Mitsubishi|ASX;Mitsubishi|Outlander;Mitsubishi|Pajero;Mitsubishi|Pajero Sport;Mitsubishi|Triton;Nissan|Navara;Nissan|Patrol;Nissan|Qashqai;Nissan|X-Trail;Subaru|Forester;Subaru|Outback;Subaru|XV;Suzuki|Jimny;Suzuki|Swift;Tesla|Model 3;Tesla|Model Y;Toyota|C-HR;Toyota|Camry;Toyota|Corolla;Toyota|Corolla Cross;Toyota|HiLux;Toyota|Kluger;Toyota|LandCruiser 200;Toyota|LandCruiser 300;Toyota|LandCruiser 70;Toyota|Prado;Toyota|RAV4;Volkswagen|Amarok;Volkswagen|Golf';

  function handleize(t) { return String(t).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function inRange(n, a, b, step) { return n >= a && n <= b && (!step || n % step === 0); }
  function inchW(w) {
    if (w.indexOf('.') >= 0) return +w;
    if (w.length === 4) return +w / 100;
    if (w.length === 3) return w.charAt(0) === '1' ? +w / 10 : +w / 100;
    return +w;
  }
  function make(kind, a, b, c) {
    var o = { kind: kind };
    if (kind === 'metric') { o.w = a; o.p = b; o.r = c; o.label = a + '/' + b + 'R' + c; o.handle = a + '-' + b + 'r' + c; o.key = '' + a + b + c; }
    else if (kind === 'inch') { var w = (+b).toFixed(2); o.d = a; o.w = w; o.r = c; o.label = a + 'x' + w + 'R' + c; o.handle = a + 'x' + w.replace('.', '-') + 'r' + c; o.key = '' + a + w.replace('.', '') + c; }
    else { o.w = a; o.r = c; o.label = a + 'R' + c; o.handle = a + 'r' + c; o.key = '' + a + 'R' + c; }
    return o;
  }
  /* what may follow a size: C / LT, load index (or dual 121/118), speed letter, XL, run-flat marks */
  var REST = /^(C|LT)?(?:(\d{2,3})(?:\/?(\d{2,3}))?([JKLMNPQRSTUHVWY]|\(Y\))?)?((?:XL|EXTRALOAD|RF|RFT|SSR|ZP|ROF|RUNFLAT|EMT|LT|C|SL|M\+S|MS|3PMSF|E|D|\*|MO|AO|N\d|TL)*)$/;
  function restOk(rest, o) {
    var r = String(rest || '').toUpperCase().replace(/[\s\/\-,.]+/g, '');
    if (!r) return true;
    var m = r.match(REST);
    if (!m) return false;
    if (m[2] && !inRange(+m[2], 50, 150)) return false;
    if (m[3] && !inRange(+m[3], 50, 150)) return false;
    if (m[4] && !m[2]) return false;
    if (/^(C)|C/.test(m[1] || '') || /(^|[^S])C/.test(m[5] || '')) o.c = true;
    if (m[1] === 'LT' || /LT/.test(m[5] || '')) o.lt = true;
    return true;
  }
  var LIST = {}, BYKEY = {}, HAS = false;
  function prep(raw) {
    var s = String(raw == null ? '' : raw).toUpperCase().replace(/[\u00a0\s]+/g, ' ').trim();
    var lt = false;
    var m = s.match(/^(LT|P|ST|HL)\s?(?=\d)/);
    if (m) { if (m[1] === 'LT') lt = true; s = s.slice(m[0].length); }
    s = s.replace(/[\/\-_,]+/g, ' ').replace(/\s+/g, ' ').trim();
    return { s: s, lt: lt };
  }
  /* every reading of the text; strict = shorthand rules, loose = anything shaped like a size (variant titles) */
  function cands(raw, loose) {
    var p = prep(raw), s = p.s, out = [], m;
    if (!s || s.length > 40 || !/^\d/.test(s)) return out;
    function add(o, rest, needKnown) {
      if (!o) return;
      o.lt = p.lt;
      if (!restOk(rest, o) && !(loose && /^(\s|[^0-9.])/.test(rest || ''))) return;
      if (needKnown && !known(o)) return;
      out.push(o);
    }
    /* metric 275/40R20, 275 40 20, 2754020, 27540ZR20, 275/40/R20, 225/55RF17, 275/40 R 20 */
    m = s.match(/^(\d{3}) ?(\d{2}) ?(?:Z ?R ?F?|R ?F|R|Z|F)? ?(\d{2})(?![.\d]?\d*\s*X)(.*)$/);
    if (m) {
      var w = +m[1], pr = +m[2], r = +m[3];
      var ok = inRange(w, 125, 355, 5) && inRange(pr, 25, 95, 5) && inRange(r, 10, 24);
      if (ok || (loose && inRange(w, 100, 405) && inRange(pr, 20, 95) && inRange(r, 10, 26))) add(make('metric', m[1], m[2], m[3]), m[4]);
      else if (inRange(w, 100, 405) && /[R\/ ]/.test(String(raw).toUpperCase()) && LIST[make('metric', m[1], m[2], m[3]).handle]) add(make('metric', m[1], m[2], m[3]), m[4]);
    }
    /* van / commercial 185R14C, 185 R14, 750R16 */
    m = s.match(/^(\d{3}) ?Z?R ?(\d{2})(?!\d)(.*)$/);
    if (m) {
      var cw = +m[1];
      if ((inRange(cw, 125, 355, 5) || inRange(cw, 500, 950, 50) || cw === 825) && inRange(+m[2], 10, 24)) add(make('com', m[1], null, m[2]), m[3]);
    }
    /* 4x4 inch with an x: 33x12.50R15, 33X12.5R15, 33x1250R15, 33x12.50-15, 33 x 12.50 R15 */
    m = s.match(/^(\d{2}) ?[X*] ?(\d{1,2}\.\d{1,2}|\d{1,4}) ?(?:Z ?R|R ?F|R)? ?(\d{2})(?!\d)(.*)$/);
    if (m) {
      var d = +m[1], iw = inchW(m[2]);
      if (inRange(d, 22, 44) && iw >= 6 && iw <= 20 && inRange(+m[3], 14, 26)) {
        var io = make('inch', m[1], iw, m[3]);
        if (m[2].indexOf('.') < 0 && m[2].length <= 2 && !known(io)) { var alt = make('inch', m[1], iw + 0.5, m[3]); if (known(alt)) io = alt; }
        add(io, m[4]);
      }
    }
    /* 4x4 inch, spaced without an x: 33 12.50 15, 33 12.5 R15 */
    m = s.match(/^(\d{2}) (\d{1,2}\.\d{1,2}) ?(?:Z?R)? ?(\d{2})(?!\d)(.*)$/);
    if (m && inRange(+m[1], 22, 44) && +m[2] >= 6 && +m[2] <= 20 && inRange(+m[3], 14, 26)) add(make('inch', m[1], +m[2], m[3]), m[4]);
    /* 4x4 inch digits only: 31105015, 311050R15, 3110515 (only sizes we know) */
    var c = s.replace(/ /g, '');
    m = c.match(/^(\d{2})(\d{3,4})(R?)(\d{2})(.*)$/);
    if (m) {
      [[m[2], m[3] + m[4], m[5]]].concat(m[2].length === 4 ? [[m[2].slice(0, 3), m[2].slice(3) + m[3] + m[4], m[5]]] : []).forEach(function (t) {
        var mm = t[1].match(/^R?(\d{2})(.*)$/); if (!mm) return;
        var o = make('inch', m[1], inchW(t[0]), mm[1]);
        add(o, mm[2] + t[2], true);
      });
    }
    return out;
  }
  function known(o) {
    if (LIST[o.handle] || LIST[o.handle + 'c']) return true;
    return o.kind === 'inch' && (' ' + KNOWN_INCH + ' ').indexOf(' ' + o.label + ' ') >= 0;
  }
  function uniq(list) {
    var seen = {}, out = [];
    list.forEach(function (o) { if (!seen[o.label]) { seen[o.label] = 1; out.push(o); } });
    return out;
  }
  function pick(list) {
    list = uniq(list);
    if (list.length === 1) return list[0];
    if (list.length > 1) {
      var k = list.filter(known);
      if (k.length === 1) return k[0];
    }
    return null;
  }
  function finish(o) {
    if (!o) return null;
    o.display = o.kind === 'com' ? o.label + (o.c ? 'C' : '') : o.label + (o.c ? 'C' : '') + (o.lt ? 'LT' : '');
    /* the size page to send people to: plain tag first, then the C tag (van sizes) */
    var h = null;
    if (o.c && LIST[o.handle + 'c']) h = o.handle + 'c';
    else if (LIST[o.handle]) h = o.handle;
    else if (LIST[o.handle + 'c']) h = o.handle + 'c';
    o.page = h;
    o.exists = !!h;
    /* plain van sizes (185R14, no profile, no C typed) also list the C tyres: 185R14 + 185R14C. 185R14C stays C-only. */
    o.also = (o.kind === 'com' && h === o.handle && LIST[o.handle + 'c']) ? o.handle + 'c' : null;
    o.url = TYRES + '/' + (h || o.handle);
    return o;
  }
  function read(raw) { return finish(pick(cands(raw, false))); }
  function canon(raw) {
    var p = prep(raw);
    if (!p.s) return null;
    /* variant titles: read the leading size and ignore the rest */
    var m = p.s.match(/^([0-9][0-9 .X*RZF]*?)(?=\s(?:\d{2,3}(?:\s\d{2,3})?[A-Z]\b|XL|RF|C\b|LT)|$)/);
    var list = cands(raw, true);
    if (!list.length && m) list = cands(m[1], true);
    if (!list.length) {
      var sp = p.s.split(' ');
      for (var i = sp.length - 1; i > 0 && !list.length; i--) list = cands(sp.slice(0, i).join(' '), true);
    }
    return finish(uniq(list)[0] || null);
  }
  /* partial sizes such as 37x12, 37, 3312, 275/40 -> sizes in the size list */
  function partial(raw) {
    var s = String(raw || '').toUpperCase().trim();
    if (!/^(LT|P)?\s?\d[\d\s\/\-.X*R]*$/.test(s)) return [];
    if (read(raw)) return [];
    var inch = /X|\*/.test(s);
    var k = s.replace(/^(LT|P)\s?/, '').replace(/[^0-9X*.]/g, '');
    var key;
    if (inch) {
      var mm = k.match(/^(\d{2})[X*](\d{0,2})(?:\.(\d{0,2}))?/);
      if (!mm) return [];
      key = mm[1] + (mm[2] || '') + (mm[3] != null ? (mm[3] + '00').slice(0, 2) : '');
    } else key = k.replace(/\./g, '');
    if (key.length < 2) return [];
    var out = [];
    Object.keys(BYKEY).forEach(function (bk) {
      var o = BYKEY[bk];
      if (inch && o.kind !== 'inch') return;
      if (key.length === 2 && o.kind !== 'inch') return;
      if (bk.replace('R', '').indexOf(key) === 0 || bk.indexOf(key) === 0) out.push(o);
    });
    out.sort(function (a, b) { return a.kind === b.kind ? a.key.localeCompare(b.key, 'en', { numeric: true }) : a.kind < b.kind ? -1 : 1; });
    return out;
  }
  var CAR = CARS.split(';').map(function (x) { var p = x.split('|'); return { mk: p[0], md: p[1], words: (p[0] + ' ' + p[1]).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim().split(' '), mdw: p[1].toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim().split(' ') }; });
  var STOP = { tyre: 1, tyres: 1, tire: 1, tires: 1, wheel: 1, wheels: 1, rim: 1, rims: 1, for: 1, my: 1, a: 1, the: 1, new: 1, size: 1, sizes: 1 };
  function vehicle(raw) {
    var q = String(raw || '').toLowerCase().replace(/land\s+cruiser/g, 'landcruiser').replace(/hi\s?lux/g, 'hilux').replace(/[^a-z0-9]+/g, ' ').trim();
    if (!q || /\d{3}/.test(q)) return null;
    var words = q.split(' ').filter(function (w) { return !STOP[w]; });
    if (!words.length) return null;
    function has(list, w) { return list.some(function (x) { return x === w || (w.length >= 4 && x.indexOf(w) === 0) || x.replace(/[^a-z0-9]/g, '') === w; }); }
    var hit = CAR.filter(function (c) {
      var joined = c.words.join('');
      return words.every(function (w) { return has(c.words, w) || joined === words.join(''); }) && words.some(function (w) { return has(c.mdw, w); });
    });
    if (hit.length > 1) {
      var exact = hit.filter(function (c) { return words.filter(function (w) { return !has([c.mk.toLowerCase()], w); }).join(' ') === c.mdw.join(' '); });
      if (exact.length === 1) hit = exact;
    }
    if (hit.length === 1) return { make: hit[0].mk, model: hit[0].md, url: TYRES + '?car=' + encodeURIComponent(hit[0].mk + '|' + hit[0].md) + '#fwt-car' };
    var mk = CAR.filter(function (c) { return words.length === 1 && c.mk.toLowerCase().replace(/[^a-z0-9]/g, '') === words[0]; });
    if (mk.length) return { make: mk[0].mk, model: '', url: TYRES + '?car=' + encodeURIComponent(mk[0].mk) + '#fwt-car' };
    return null;
  }
  /* where a header search should go: size page, rewritten search, or the car finder */
  function route(raw) {
    var q = String(raw || '').trim();
    if (!q) return null;
    var r = read(q);
    if (r) return r.exists || !HAS ? { type: 'size', size: r, url: r.url } : { type: 'search', size: r, url: '/search?q=' + encodeURIComponent(r.display) + '&type=product&fwt=1' };
    var v = vehicle(q);
    if (v) return { type: 'car', car: v, url: v.url };
    /* a size inside other words: michelin 2754020 -> michelin 275/40R20 */
    var parts = q.split(/\s+/), changed = false;
    if (parts.length > 1) {
      parts = parts.map(function (t) { var x = /\d{5,}/.test(t) ? read(t) : null; if (x) { changed = true; return x.display; } return t; });
      if (changed) return { type: 'search', url: '/search?q=' + encodeURIComponent(parts.join(' ')) + '&type=product&fwt=1' };
    }
    return null;
  }
  function load(str) {
    String(str || '').split('|').forEach(function (t) {
      t = t.trim(); if (!t) return;
      var o = cands(t, true)[0];
      if (!o) return;
      LIST[handleize(t)] = t;
      HAS = true;
      if (!BYKEY[o.key]) BYKEY[o.key] = o;
    });
    Object.keys(BYKEY).forEach(function (k) { finish(BYKEY[k]); });
  }
  load(window.FWT_SZ);
  window.FWTSize = { read: read, canon: canon, partial: partial, vehicle: vehicle, route: route, list: function () { return Object.keys(BYKEY).map(function (k) { return BYKEY[k]; }); }, exists: function (h) { return !!LIST[h]; } };

  /* ---- header and search-page forms: route on submit (capture, before the theme's own handlers) ---- */
  function isSearchForm(f) {
    if (!f || f.hasAttribute('data-fwt-tyres') || f.closest('#fwt-finder')) return false;
    var a = (f.getAttribute('action') || '').split('?')[0];
    return /\/search\/?$/.test(a) && !!f.querySelector('input[name="q"]');
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!isSearchForm(f)) return;
    var q = f.querySelector('input[name="q"]').value;
    var r = route(q);
    if (!r) return;
    e.preventDefault(); e.stopImmediatePropagation();
    location.href = r.url;
  }, true);
  /* search results reached any other way (suggestion links, typed URLs) */
  if (/^\/search\/?$/.test(location.pathname)) {
    var sp = new URLSearchParams(location.search), sq = sp.get('q');
    if (sq && !sp.get('fwt') && !sp.get('page')) {
      var rr = route(sq);
      if (rr && (rr.type !== 'search' || rr.url.indexOf(encodeURIComponent(sq)) < 0)) location.replace(rr.url);
    }
  }
  /* ---- predictive search: size queries ask the size page for its in-stock tyres, partial sizes and cars get a shortcut ---- */
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function extra(q) {
    var v = vehicle(q);
    if (v) return '<div class="search-flydown__queries-collections fwt-ps-extra"><h3 class="search-flydown__group-title">Find tyres by car</h3><ul class="search-flydown__group-list"><li class="search-flydown__list-item"><a href="' + esc(v.url) + '">Tyre sizes for the ' + esc((v.make + ' ' + v.model).trim()) + ' &rarr;</a></li></ul></div>';
    var p = partial(q);
    if (p.length) {
      return '<div class="search-flydown__queries-collections fwt-ps-extra"><h3 class="search-flydown__group-title">Matching tyre sizes</h3><ul class="search-flydown__group-list fwt-ps-sizes">' +
        p.slice(0, 12).map(function (o) { return '<li class="search-flydown__list-item"><a href="' + esc(o.url) + '">' + esc(o.label) + '</a></li>'; }).join('') +
        (p.length > 12 ? '<li class="search-flydown__list-item"><a href="/search?q=' + encodeURIComponent(q) + '&type=product&fwt=1">+ ' + (p.length - 12) + ' more sizes</a></li>' : '') + '</ul></div>';
    }
    return '';
  }
  /* one suggestion list for 185R14 + 185R14C: union of both size pages' in-stock tyres, cheapest first */
  function mergePs(ha, hb, r) {
    try {
      var P = new DOMParser(), A = P.parseFromString(ha, 'text/html'), B = P.parseFromString(hb, 'text/html');
      var wa = A.querySelector('.fwt-ps-size'), wb = B.querySelector('.fwt-ps-size');
      if (!wa || !wb) return null;
      var ma = wa.getAttribute('data-fwt-mode'), mb = wb.getAttribute('data-fwt-mode');
      var ha_ = (wa.getAttribute('data-fwt-all') || '').split(' ').filter(Boolean), hb_ = (wb.getAttribute('data-fwt-all') || '').split(' ').filter(Boolean);
      /* fill-in brands only when neither size has anything else */
      var useA = ha_.length && (ma === 'main' || mb !== 'main' || !hb_.length), useB = hb_.length && (mb === 'main' || ma !== 'main' || !ha_.length);
      var all = {}, items = {};
      function take(doc, ok, hs) {
        if (!ok) return;
        hs.forEach(function (h) { all[h] = 1; });
        doc.querySelectorAll('.search-flydown--product-items li[data-fwt-p]').forEach(function (li) {
          var a = li.querySelector('a[href*="/products/"]'); if (!a) return;
          var k = (a.getAttribute('href').match(/\/products\/([^?#\/]+)/) || [])[1]; if (!k) return;
          var p = +li.getAttribute('data-fwt-p');
          if (!items[k] || p < items[k].p) items[k] = { p: p, li: li };
        });
      }
      take(A, useA, ha_); take(B, useB, hb_);
      var n = Object.keys(all).length, label = r.label, both = r.label + ' and ' + r.label + 'C';
      var list = Object.keys(items).map(function (k) { return items[k]; }).sort(function (x, y) { return x.p - y.p; }).slice(0, 8);
      var block = wa.querySelector('.search-flydown__products-pages-posts');
      if (!block && list.length) { var bb = wb.querySelector('.search-flydown__products-pages-posts'); if (bb) { block = A.importNode(bb, true); wa.appendChild(block); } }
      if (block) {
        var ul = block.querySelector('.search-flydown--product-items ul');
        if (ul) { ul.innerHTML = ''; list.forEach(function (it) { ul.appendChild(A.importNode(it.li, true)); }); }
        var h3 = block.querySelector('.search-flydown__group-title'); if (h3) h3.textContent = 'In stock in ' + both + ', cheapest first';
        if (!list.length) block.remove();
      }
      var allA = wa.querySelector('.fwt-ps-all a');
      if (allA) allA.innerHTML = n ? 'See all ' + n + (n === 1 ? ' tyre' : ' tyres') + ' in ' + esc(label) + ' (incl. ' + esc(label) + 'C van) &rarr;' : esc(label) + ': we can source this size &rarr;';
      var t = wa.querySelector('.search-flydown__queries-collections .search-flydown__group-title'); if (t) t.textContent = 'Tyre size ' + both;
      wa.setAttribute('data-fwt-all', Object.keys(all).join(' '));
      return A.body.innerHTML;
    } catch (e) { return null; }
  }
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (url.indexOf('/search/suggest') >= 0 && url.indexOf('section_id=') >= 0) {
          var u = new URL(url, location.origin), q = u.searchParams.get('q') || '';
          var r = read(q);
          if (r && r.exists) {
            var sid = '?section_id=' + encodeURIComponent(u.searchParams.get('section_id')) + '&fwt_q=' + encodeURIComponent(q);
            if (r.also && window.DOMParser) {
              var self = this;
              return Promise.all([of.call(self, r.url + sid, init), of.call(self, TYRES + '/' + r.also + sid, init).catch(function () { return null; })]).then(function (rs) {
                var a = rs[0], b = rs[1];
                if (!b || !b.ok) return a;
                return Promise.all([a.clone().text(), b.text()]).then(function (t) {
                  var out = mergePs(t[0], t[1], r);
                  return out ? new Response(out, { status: a.status, statusText: a.statusText, headers: a.headers }) : a;
                });
              });
            }
            return of.call(this, r.url + sid, init);
          }
          var add = extra(q);
          if (add) {
            return of.apply(this, arguments).then(function (res) {
              return res.text().then(function (html) {
                var out = html.replace(/(<div[^>]*id="shopify-section-[^"]*"[^>]*>\s*<div>)/, '$1' + add);
                if (out === html) out = add + html;
                return new Response(out, { status: res.status, statusText: res.statusText, headers: res.headers });
              });
            });
          }
        }
      } catch (e) {}
      return of.apply(this, arguments);
    };
  }
})();
